export const SET_USER_PROFILE = 'user/SET_USER_PROFILE'
export const SET_USER_PREFERENCE = 'user/SET_USER_PREFERENCE'
export const INITIAL_USER_PREFERENCE = 'user/INITIAL_USER_PREFERENCE'
export const RESET_USER_PREFERENCE_FOR_MERCHANT = 'user/RESET_USER_PREFERENCE_FOR_MERCHANT'
